export default "__VITE_ASSET__B2J2Jqrj__"